/**
 * Admin Dashboard Hooks
 * ---------------------
 * React Query hooks for admin dashboard data.
 */

import { useQuery } from '@tanstack/react-query';
import * as adminDashboardService from '../services/adminDashboardService';

const ADMIN_DASHBOARD_KEY = ['admin-dashboard'];

/**
 * Hook to get system health status
 */
export const useSystemHealth = () =>
  useQuery({
    queryKey: [...ADMIN_DASHBOARD_KEY, 'system-health'],
    queryFn: adminDashboardService.getSystemHealth,
    refetchInterval: 30000, // Refresh every 30 seconds
    staleTime: 10000, // Consider stale after 10 seconds
  });

/**
 * Hook to get matching diagnostics for all users
 */
export const useMatchingDiagnostics = () =>
  useQuery({
    queryKey: [...ADMIN_DASHBOARD_KEY, 'matching-diagnostics'],
    queryFn: adminDashboardService.getMatchingDiagnostics,
    staleTime: 60000, // Consider stale after 1 minute
  });

/**
 * Hook to get admin user list
 */
export const useAdminUserList = () =>
  useQuery({
    queryKey: [...ADMIN_DASHBOARD_KEY, 'user-list'],
    queryFn: adminDashboardService.getAdminUserList,
    staleTime: 60000,
  });

/**
 * Hook to get wiring audit - truth-based health check
 * Based on latest user journey, not aggregate counts
 */
export const useWiringAudit = () =>
  useQuery({
    queryKey: [...ADMIN_DASHBOARD_KEY, 'wiring-audit'],
    queryFn: adminDashboardService.getWiringAudit,
    refetchInterval: 30000, // Refresh every 30 seconds
    staleTime: 10000,
  });
